import { useEffect, useState } from 'react'
import { getCookie, setCookie } from '../../../../utils'
import { mainCurrencies, currencies, currenciesCodesList } from '../currencies'
import { setCurrency as setSelectedCurrency } from '../../../../actions/main-actions'

const DEFAULT_CURRENCY = 'USD'

export default function useCurrencies() {
  const [currency, setCurrency] = useState(null)

  const dispatch = window?.store?.dispatch

  useEffect(() => {
    const currencyFromCookie = getCookie('currency_code')
    if(!currencyFromCookie) {
      setCurrencyCookie(DEFAULT_CURRENCY)
      setCurrency(DEFAULT_CURRENCY)
      dispatch(setSelectedCurrency(DEFAULT_CURRENCY))
    } else if(currencyFromCookie !== currency) {
      setCurrency(currencyFromCookie)
      dispatch(setSelectedCurrency(currencyFromCookie))
    }
  }, [])

  function setCurrencyCookie(currency) {
    setCookie('currency_code', currency, {
      path: '/',
      domain:
        process.env.ENVIRONMENT === 'production'
          ? '.padi.com'
          : window.location.hostname,
    })
  }

  function changeCurrency(currency) {
    setCurrency(currency)
    setCurrencyCookie(currency)
    dispatch(setSelectedCurrency(currency))
  }

  return {
    currency,
    changeCurrency,
    mainCurrencies,
    currencies,
    currenciesCodesList,
  }
}
